import apiClient from './client';
import { API_ENDPOINTS } from './endpoints';

export interface AuditLog {
  id: string;
  user: string;
  user_name: string;
  ip_address: string;
  user_agent: string;
  action: string;
  resource_type: string;
  resource_id: string;
  description: string;
  old_value: any;
  new_value: any;
  created_at: string;
  company: string;
  company_name: string;
}

export const auditApi = {
  list: async (params?: Record<string, any>): Promise<{ results: AuditLog[]; count: number }> => {
    const response = await apiClient.get(API_ENDPOINTS.AUDIT.LIST, { params });
    return response.data;
  },

  get: async (id: string): Promise<AuditLog> => {
    const response = await apiClient.get(API_ENDPOINTS.AUDIT.DETAIL(id));
    return response.data;
  },
};
